var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "article_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 3.25H20.5833C21.775 3.25 22.75 4.225 22.75 5.41667V20.5833C22.75 21.775 21.775 22.75 20.5833 22.75H5.41667C4.225 22.75 3.25 21.775 3.25 20.5833V5.41667C3.25 4.225 4.225 3.25 5.41667 3.25ZM7.58333 18.4167H15.1667V16.25H7.58333V18.4167ZM18.4167 14.0833H7.58333V11.9167H18.4167V14.0833ZM7.58333 9.75H18.4167V7.58333H7.58333V9.75Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collection.ef151803d0228e7f5835c7351f12ebf7.svg";